import type { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import MuiLink from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { PagePaths } from "@/partner/shared/constants";

export interface BuyerEmailCellProps {
  email?: string | null;
  /** Есть id: адрес ведёт в карточку зрителя, иначе это просто текст. */
  userId?: string | null;
  /** Чем заменить пустой адрес, обычно прочерк списка. */
  emptyValue: string;
}

/**
 * Адрес покупателя в списках платежей, покупок, подписок, возвратов и
 * споров. Длинные адреса раньше вылезали за ячейку и наезжали на соседний
 * текст: ширина ограничивалась у самой ячейки, а ссылка внутри оставалась
 * строчной и не обрезалась. Здесь адрес обрезается многоточием, а целиком
 * его видно во всплывающей подсказке.
 */
export const BuyerEmailCell: FC<BuyerEmailCellProps> = ({
  email,
  userId,
  emptyValue,
}) => {
  if (!email) {
    return <Typography variant="body2">{emptyValue}</Typography>;
  }

  const text = (
    <Typography
      component="span"
      variant="body2"
      title={email}
      sx={{
        display: "block",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {email}
    </Typography>
  );

  if (!userId) return text;

  return (
    <MuiLink
      component={RouterLink}
      color="secondary"
      target="_blank"
      to={`${PagePaths.users}?tab=details&id=${userId}`}
      onClick={(event) => event.stopPropagation()}
      sx={{ display: "block", maxWidth: "100%", overflow: "hidden" }}
    >
      {text}
    </MuiLink>
  );
};
